import { apiGet, apiPost, apiPatch, apiDelete } from '@/app/api/core/http';
import { createImage, updateImage, uploadImages } from '@/app/api/core/images';
import { CAT_COMPANIES } from 'App/utils/Collections';
import { COMPANIES_PATHS } from './paths';

export const companiesApiAdapter = {
  getCompanies: (params, cat, headers) => {
    const { clearParams, ...rest } = params;
    let preparedParams = {
      params: rest,
      clearParams,
      is_protected: true,
    };
    if (headers) {
      preparedParams.headers = headers.headers;
    }
    return apiGet(COMPANIES_PATHS.companies + COMPANIES_PATHS.suffix, preparedParams);
  },
  getCompanyDetails: (id, headers) => {
    if (headers) {
      return apiGet(`${COMPANIES_PATHS.companies}/${id}`, {
        headers: headers,
        is_protected: true,
      });
    } else {
      return apiGet(`${COMPANIES_PATHS.companies}/${id}`, { is_protected: true });
    }
  },
  getCompaniesStats: () => apiGet(COMPANIES_PATHS.stats),
  createCompany: async (data) => {
    const res = await apiPost(COMPANIES_PATHS.companies, { data, is_protected: true });
    await uploadImages(CAT_COMPANIES, data.images, {
      company_id: res.data.id,
    }).catch();
    return res;
  },
  updateCompany: async (id, data) => {
    if (data.foundationYear === '') {
      data.foundationYear = null;
    }
    const res = await apiPatch(`${COMPANIES_PATHS.companies}/${id}`, {
      data,
      is_protected: true,
    });
    if (data.images) {
      const images = data.images.filter((img) => img.isNew || img.isDirty);
      await uploadImages(CAT_COMPANIES, images, { company_id: id }).catch();
    }
    return res;
  },
  getCompaniesHistory: (id) => apiGet(`${COMPANIES_PATHS.companies}/${id}/history`),
  getCompaniesSnapshotById: (id, snapshot_id) =>
    apiGet(`${COMPANIES_PATHS.companies}/${id}/history/snapshots/${snapshot_id}`),
  [CAT_COMPANIES]: {
    remove: (id) => apiDelete(`${COMPANIES_PATHS.companies}/${id}`, { is_protected: true }),
  },
  companyImages: {
    create: (img, company_id, is_default = false, session_interval = 0) =>
      createImage(CAT_COMPANIES, img, { company_id, is_default, session_interval }),
    update: (id, data) => updateImage(CAT_COMPANIES, id, data),
    remove: (id) => apiDelete(`${COMPANIES_PATHS.images}/${id}`),
    getList: (company_id, params = {}) =>
      apiGet(COMPANIES_PATHS.images, {
        params: {
          ...params,
          'company.id': company_id,
        },
      }),
  },
};

export const companiesFilterAdapter = {
  getCompanyCategories: (params) => apiGet(COMPANIES_PATHS.categories, params),
};
